import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { marked } from 'marked';
import { applyLegalPlaceholders } from '@noisy/legal';
import { legalPlaceholders } from '../config/legal-config';

@Injectable({ providedIn: 'root' })
export class LegalContentService {
  private http = inject(HttpClient);

  loadMarkdown(path: string): Observable<string> {
    return this.http.get(path, { responseType: 'text' }).pipe(
      map((content) => this.renderMarkdown(content)),
    );
  }

  private renderMarkdown(content: string): string {
    const replaced = applyLegalPlaceholders(content, legalPlaceholders);
    return marked.parse(replaced, { breaks: true }) as string;
  }
}
